import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-bucket.svg'
import _imports_1 from '@/assets/icons/icon-paper.svg'
import _imports_2 from '@/assets/icons/plus-black.svg'


const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "customer-documents-desktop" }
const _hoisted_3 = { class: "customer__container" }
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = {
  key: 2,
  class: "wrapper-table"
}
const _hoisted_6 = { class: "table-default" }
const _hoisted_7 = { class: "document-main-info" }
const _hoisted_8 = { class: "document-date" }
const _hoisted_9 = { class: "document-type" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "customer-documents-mobile" }
const _hoisted_13 = { class: "header" }
const _hoisted_14 = {
  key: 0,
  class: "spinner"
}
const _hoisted_15 = {
  key: 2,
  class: "card"
}
const _hoisted_16 = { class: "document-body" }
const _hoisted_17 = { class: "document-content" }
const _hoisted_18 = { class: "document-content__name" }
const _hoisted_19 = { class: "document-content__type" }
const _hoisted_20 = { class: "document-content__date" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "description--highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "header" }, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "customer__title" }, "My Documents", -1)),
          _createElementVNode("button", {
            class: "button button-primary-with-icon plus",
            onClick: $setup.onUploadButton
          }, "Upload documents")
        ]),
        ($setup.showSpinner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true),
        (!$setup.documents.length && !$setup.showSpinner)
          ? (_openBlock(), _createBlock($setup["CustomerDetailsCardEmpty"], {
              key: 1,
              "img-path": "assets/icons/icon-customer-documents.svg",
              message: "No documents uploaded"
            }))
          : _createCommentVNode("", true),
        ($setup.documents.length && !$setup.showSpinner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Document"),
                    _createElementVNode("th", null, "Uploaded"),
                    _createElementVNode("th", null, "Document type"),
                    _createElementVNode("th", { class: "head-item--actions" })
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documents, (document, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_7, [
                        (_openBlock(), _createBlock($setup["DocumentItem"], {
                          class: "block-documents--item",
                          key: index,
                          link: document.link,
                          name: document.name
                        }, null, 8, ["link", "name"]))
                      ]),
                      _createElementVNode("td", _hoisted_8, _toDisplayString($setup.formatDateMonthDayYear(document.modifiedDate)), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(document.documentType), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "wrapper-dots",
                          onClick: _withModifiers(($event: any) => ($setup.onDots(index)), ["stop"])
                        }, [
                          _createVNode($setup["ActionsComponent"], {
                            class: "cursor-pointer",
                            "is-active": $setup.activeRowIndex === index,
                            position: $setup.getDropdownPosition(index),
                            onClickOutside: $setup.clickOutside
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "action-default",
                                onClick: ($event: any) => ($setup.showDeleteFileModal(document.name, index))
                              }, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("img", { src: _imports_0 }, null, -1),
                                _createElementVNode("span", null, "Delete", -1)
                              ]))], 8, _hoisted_11),
                              _createElementVNode("div", {
                                class: "action-default",
                                onClick: $setup.onDownload
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("img", { src: _imports_1 }, null, -1),
                                _createElementVNode("span", null, "Download File", -1)
                              ]))])
                            ]),
                            _: 2
                          }, 1032, ["is-active", "position"])
                        ], 8, _hoisted_10)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "customer__title" }, "My Documents", -1)),
        _createElementVNode("div", {
          class: "wrapper-dots",
          onClick: _withModifiers($setup.onDocumentsDots, ["stop"])
        }, [
          _createVNode($setup["ActionsComponent"], {
            class: "cursor-pointer",
            "is-active": $setup.showDocumentsActions,
            onClickOutside: $setup.clickOutsideDocuments
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "action-default",
                onClick: $setup.onUploadButton
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("img", { src: _imports_2 }, null, -1),
                _createElementVNode("span", null, "Upload documents", -1)
              ]))])
            ]),
            _: 1
          }, 8, ["is-active"])
        ])
      ]),
      ($setup.showSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : _createCommentVNode("", true),
      (!$setup.documents.length && !$setup.showSpinner)
        ? (_openBlock(), _createBlock($setup["CustomerDetailsCardEmpty"], {
            key: 1,
            "img-path": "assets/icons/icon-customer-documents.svg",
            message: "No documents uploaded"
          }))
        : _createCommentVNode("", true),
      ($setup.documents.length && !$setup.showSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documents, (document, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "document-mobile",
                key: index
              }, [
                (_openBlock(), _createBlock($setup["DocumentItemWithSlot"], {
                  class: "block-documents--item",
                  key: index,
                  link: document.link,
                  name: document.name,
                  classes: { preview: 'document-preview', container: 'document-item-container' }
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(document.name), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(document.documentType), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString($setup.formatDateMonthDayYear(document.modifiedDate)), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "wrapper-dots",
                        onClick: _withModifiers(($event: any) => ($setup.onDots(index)), ["stop"])
                      }, [
                        _createVNode($setup["ActionsComponent"], {
                          class: "cursor-pointer",
                          "is-active": $setup.activeRowIndex === index,
                          position: $setup.getDropdownPosition(index),
                          onClickOutside: $setup.clickOutside
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "action-default",
                              onClick: ($event: any) => ($setup.showDeleteFileModal(document.name, index))
                            }, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("img", { src: _imports_0 }, null, -1),
                              _createElementVNode("span", null, "Delete", -1)
                            ]))], 8, _hoisted_22),
                            _createElementVNode("div", {
                              class: "action-default",
                              onClick: $setup.onDownload
                            }, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("img", { src: _imports_1 }, null, -1),
                              _createElementVNode("span", null, "Download File", -1)
                            ]))])
                          ]),
                          _: 2
                        }, 1032, ["is-active", "position"])
                      ], 8, _hoisted_21)
                    ])
                  ]),
                  _: 2
                }, 1032, ["link", "name"]))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode($setup["CustomerUploaderModal"], {
      "is-open": $setup.isOpenedModal,
      onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenedModal = false)),
      onAfterSuccessUpload: _cache[1] || (_cache[1] = ($event: any) => ($setup.afterSuccessUpload($event)))
    }, null, 8, ["is-open"]),
    _createVNode($setup["RemoveDocumentsModal"], {
      "is-open": $setup.isOpenRemoveDocumentsModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isOpenRemoveDocumentsModal = false)),
      onConfirm: $setup.onDelete
    }, {
      title: _withCtx(() => [...(_cache[11] || (_cache[11] = [
        _createElementVNode("span", { class: "description--highlighted" }, "Confirm action", -1)
      ]))]),
      description: _withCtx(() => [
        _cache[12] || (_cache[12] = _createTextVNode("Are you sure you want to delete file '", -1)),
        _createElementVNode("span", _hoisted_23, _toDisplayString($setup.fileForDelete.file) + "' ?", 1)
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}